import * as React from 'react';
import { Col, Row, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';
import { useAppSelector } from '../../../hooks/index';
import { selectUserRole, UserRoleEnum } from '../../../redux/UserSlice';



interface LinkData {
    key: number;
    linkTo: string;
    linkName: string;
}

interface BreadCrumbData {
    key: string;
    links: Array<LinkData>;
    active: string;
}

const baseSetOfBreadCrumbs: BreadCrumbData[] =
    new Array(
        {
            key: "/", links: [],
            active: "Home"
        },
        {
            key: "/Login", links: [],
            active: "Login"
        },
        {
            key: "/AdminMenu", links: [],
            active: "Main Menu"
        },
        {
            key: "/EntityMenu", links: [],
            active: "Main Menu"
        },
        {
            key: "/AFRAssignment", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "AFR Assignment"
        },
        {
            key: "/AFRAssignment939", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
            ],
            active: "Court Reporting 939 Assignment"
        },
        {
            key: "/CR29Assignments", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
            ],
            active: "Court Reporting 29 Assignment"
        },
        {
            key: "/AuditFirmManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Audit Firm Management"
        },
        {
            key: "/CreateAFRs", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Create Annual Financial Reports"
        },
        {
            key: "/EntityAFRManagement", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" }],
            active: "Annual Financial Report"
        },
        {
            key: "/EntityAFRManagementA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Annual Financial Report"
        },
        {
            key: "/AdminAFRManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Admin Annual Financial Report Management"
        },
        {
            key: "/AdminManager", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Admin Management"
        },
        {
            key: "/EntityManagement", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" }],
            active: "Entity Management"
        },
        {
            key: "/EntityManagementA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Entity Management"
        },
        {
            key: "/AdminEntityManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Admin Entity Management"
        },
        {
            key: "/DepartmentStaffManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Department Staff Management"
        },
        {
            key: "/AccountCodeManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Fund And Account Code Management"
        },
        {
            key: "/TaxonomyManagement", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Upload, Update or Generate Taxonomies"
        },
        {
            key: "/CourtReportingOptions", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" }],
            active: "Upload and Review 939.185 and 29.0085 Court Reports"
        },
        {
            key: "/CreateCourtReports939", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
            ],
            active: "Create new Court Reports 939.185"
        },
        {
            key: "/CreateCourtReports29", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
            ],
            active: "Create new Court Reports 29.0085"
        },
        {
            key: "/AccountCodeManagementCR", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
            ],
            active: "Court Reporting Account Code Management"
        },
        {
            key: "/AfrSummary", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Summary"
        },
        {
            key: "/AfrReports", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Reports"
        },
        {
            key: "/BalanceSheet", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Balance Sheet"
        },
        {
            key: "/Revenues", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Revenues"
        },
        {
            key: "/Expenditures", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Expenditures"
        },
        {
            key: "/AccountsByGovernmental", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Accounts By Governmental"
        },
        {
            key: "/AccountsByProprietary", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Accounts By Proprietary"
        },
        {
            key: "/AccountsByFiduciary", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Accounts By Fiduciary"
        },
        {
            key: "/AccountsByComponentUnits", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Accounts By Component Units"
        },
        {
            key: "/LongTermDebt", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Long-Term Debt"
        },
        {
            key: "/AfrData", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Supplemental Information"
        },
        {
            key: "/AffiliatedEntities", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Affiliated Entities"
        },
        {
            key: "/Audit", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Audit"
        },
        {
            key: "/Certification", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Certification"
        },
        {
            key: "/AfrDataImport", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Import AFR Data"
        },
        {
            key: "/Errors", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagement", linkName: "Annual Financial Report" }],
            active: "Errors"
        },
        {
            key: "/AfrSummaryA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Summary"
        },
        {
            key: "/AfrReportsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Reports"
        },
        {
            key: "/BalanceSheetA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Balance Sheet"
        },
        {
            key: "/RevenuesA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Revenues"
        },
        {
            key: "/ExpendituresA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Expenditures"
        },
        {
            key: "/AccountsByGovernmentalA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Accounts By Governmental"
        },
        {
            key: "/AccountsByProprietaryA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Accounts By Proprietary"
        },
        {
            key: "/AccountsByFiduciaryA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Accounts By Fiduciary"
        },
        {
            key: "/AccountsByComponentUnitsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Accounts By Component Units"
        },
        {
            key: "/LongTermDebtA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Long-Term Debt"
        },
        {
            key: "/AfrDataA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Supplemental Information"
        },
        {
            key: "/AffiliatedEntitiesA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Affiliated Entities"
        },
        {
            key: "/AuditA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Audit"
        },
        {
            key: "/CertificationA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Certification"
        },
        {
            key: "/AfrDataImportA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Import AFR Data"
        },
        {
            key: "/ErrorsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/EntityAFRManagementA", linkName: "Annual Financial Report" }],
            active: "Errors"
        },
        {
            key: "/CourtReporting939CI", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 939 Data - Court Innovations"
        },
        {
            key: "/CourtReporting939CIA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 939 Data - Court Innovations"
        },
        {
            key: "/CourtReporting939LAP", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 939 Data -  Legal Aid Program"
        },
        {
            key: "/CourtReporting939LAPA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 939 Data - Legal Aid Program"
        },
        {
            key: "/CourtReporting939LL", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 939 Data - Law Library"
        },
        {
            key: "/CourtReporting939LLA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 939 Data - Law Library"
        },
        {
            key: "/CourtReporting939JAP", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 939 Data - Juvenile Alternative Program"
        },
        {
            key: "/CourtReporting939JAPA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 939 Data - Juvenile Alternative Program"
        },
        {
            key: "/CourtReporting939ImportExport", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Import or Export 939 data"
        },
        {
            key: "/CourtReporting939ImportExportA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Import or Export 939 data"
        },
        {
            key: "/CourtReporting939Summary", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Summary 939 data"
        },
        {
            key: "/CourtReporting939SummaryA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Summary 939 data"
        },
        {
            key: "/CourtReporting939Admin", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Administration"
        },
        {
            key: "/CourtReporting939AdminA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Administration"
        },
        {
            key: "/CR939Errors", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Errors"
        },
        {
            key: "/CR939ErrorsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Errors"
        },
        {
            key: "/CR939Reports", links: [
            ],
            active: "Reports"
        },
        {
            key: "/CR939ReportsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/939CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Reports"
        },
        {
            key: "/CR29ImportExport", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Import or Export 29.0085 data"
        },
        {
            key: "/CR29ImportExportA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Import or Export 29.0085 data"
        },
        {
            key: "/CR29Admin", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Administration"
        },
        {
            key: "/CR29AdminA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Administration"
        },
        {
            key: "/CR29DataAA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 29.0085 Data - Part A"
        },
        {
            key: "/CR29DataA", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 29.0085 Data - Part A"
        },
        {
            key: "/CR29DataBA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 29.0085 Data - Part B"
        },
        {
            key: "/CR29DataB", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 29.0085 Data - Part B"
        },
        {
            key: "/CR29DataCA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 29.0085 Data - Part C"
        },
        {
            key: "/CR29DataC", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 29.0085 Data - Part C"
        },
        {
            key: "/CR29DataDA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 29.0085 Data - Part D"
        },
        {
            key: "/CR29DataD", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 29.0085 Data - Part D"
        },
        {
            key: "/CR29DataEA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 939.185 Court Reports" }
            ],
            active: "Review 29.0085 Data - Part E"
        },
        {
            key: "/CR29DataE", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
            ],
            active: "Review 29.0085 Data - Part E"
        },
        {
            key: "/CR29Errors", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Errors"
        },
        {
            key: "/CR29ErrorsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Errors"
        },
        {
            key: "/Instructions", links: [
                { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Instructions"
        },
        {
            key: "/InstructionsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Instructions"
        },
        {
            key: "/CR29Certification", links: [
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Certification"
        },
        {
            key: "/CR29CertificationA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Certification"
        },
        {
            key: "/CR29Reports", links: [
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Reports"
        },
        {
            key: "/CR29ReportsA", links: [
                { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
                { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" },
                { key: 3, linkTo: "/29CourtReporting", linkName: "Upload and Review 29.0085 Court Reports" }
            ],
            active: "Reports"
        },

    );

const AdminBreadCrumbs: BreadCrumbData[] = new Array(
    {
        key: "/939CourtReporting", links: [
            { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
            { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
        ],
        active: "Upload and Review 939.185 Court Reports"
    },
    {
        key: "/29CourtReporting", links: [
            { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
            { key: 2, linkTo: "/CourtReportingOptions", linkName: "Court Reporting" }
        ],
        active: "Upload and Review 29.0085 Court Reports"
    },
    {
        key: "/PublicReportsMenu", links: [
            { key: 1, linkTo: "/AdminMenu", linkName: "Main Menu" },
        ],
        active: "Public Reports Menu"
    });

const AnonymousBreadCrumbs: BreadCrumbData[] = new Array(
    {
        key: "/PublicReportsMenu", links: [
            { key: 1, linkTo: "/Login", linkName: "Home" },
        ],
        active: "Public Reports Menu"
    });

const EntityBreadCrumbs: BreadCrumbData[] = new Array(
    {
        key: "/939CourtReporting", links: [
            { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
        ],
        active: "Upload and Review 939.185 Court Reports"
    },
    {
        key: "/29CourtReporting", links: [
            { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
        ],
        active: "Upload and Review 29.0085 Court Reports"
    },
    {
        key: "/PublicReportsMenu", links: [
            { key: 1, linkTo: "/EntityMenu", linkName: "Main Menu" },
        ],
        active: "Public Reports Menu"
    });

const Navigation = () => {

    const locationPath = useLocation().pathname;
    var userRoleSelector = useAppSelector(selectUserRole);

    const [allPossibleBreadCrumbs, setAllPossibleBreadCrumbs] = React.useState<BreadCrumbData[]>(baseSetOfBreadCrumbs);
    const [activeBreadCrumb, setActiveBreadCrumb] = React.useState<BreadCrumbData>(baseSetOfBreadCrumbs[1]);


    const mergeBaseCrumbsWithUserCrumbs = (userType: 'Admin' | 'Entity' | 'Anonymous'): BreadCrumbData[] => {

        var result: BreadCrumbData[] = [];

        switch (userType) {
            case 'Admin':
                result = baseSetOfBreadCrumbs.concat(AdminBreadCrumbs);
                break;
            case 'Entity':
                result = baseSetOfBreadCrumbs.concat(EntityBreadCrumbs);
                break;
            case 'Anonymous':
                result = baseSetOfBreadCrumbs.concat(AnonymousBreadCrumbs);
                break;

            default:
        }

        return result;
    }

    React.useEffect(() => {

        if (userRoleSelector) {
            if (userRoleSelector == UserRoleEnum.Admin) {
                setAllPossibleBreadCrumbs(mergeBaseCrumbsWithUserCrumbs('Admin'));
            } else if (userRoleSelector == UserRoleEnum.EntityUser) {
                setAllPossibleBreadCrumbs(mergeBaseCrumbsWithUserCrumbs('Entity'));
            }
        } else {
            setAllPossibleBreadCrumbs(mergeBaseCrumbsWithUserCrumbs('Anonymous'));
        }
    }, [userRoleSelector]);

    React.useEffect(() => {

        if (locationPath != activeBreadCrumb.key) {
            var breadCrumbListWithActiveCrumb: BreadCrumbData | undefined = allPossibleBreadCrumbs.find((x: BreadCrumbData) => x.key.toLowerCase()
                                                                                                                                == locationPath.toLowerCase());
            if (breadCrumbListWithActiveCrumb === undefined) {
                breadCrumbListWithActiveCrumb = baseSetOfBreadCrumbs[0];
            }

            setActiveBreadCrumb(breadCrumbListWithActiveCrumb);
        }
    }, [locationPath]);

    return (
        <Row className="Navigation">
            <Col md="12">

                <Breadcrumb>
                    {activeBreadCrumb.links.map((crumb: any) => (
                        <BreadcrumbItem key={crumb.key}>
                            <Link to={crumb.linkTo}>
                                {crumb.linkName}
                            </Link>
                        </BreadcrumbItem>
                    ))}
                    <BreadcrumbItem active>{activeBreadCrumb.active}</BreadcrumbItem>
                </Breadcrumb>
            </Col>
        </Row>

    );
}

export default Navigation;